import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39bd0c01"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  id: "address"
}
const _hoisted_2 = { class: "mt-2 mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-black h6" }, "Business Information (optional)", -1))
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-black" }, "Business Name", -1))
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-black" }, "Tax Identifier", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-black h6" }, "Address", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6 mt-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-black" }, "Country Code", -1))
const _hoisted_13 = { class: "col-md-6 mt-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-black" }, "Region (optional)", -1))
const _hoisted_15 = { class: "col-md-6 mt-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-black" }, "Street", -1))
const _hoisted_17 = { class: "col-md-6 mt-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-black" }, "Postal Code", -1))
const _hoisted_19 = { class: "col-md-6 mt-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-black" }, "City", -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "text-danger mt-4 ps-1"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "clearfix" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "ChatApp Inc.",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.businessInformation.business.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.businessInformation.business.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "555952383",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.businessInformation.business.taxIdentifier) = $event))
          }, null, 512), [
            [_vModelText, _ctx.businessInformation.business.taxIdentifier]
          ])
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "DE",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.businessInformation.address.countryCode) = $event))
        }, null, 512), [
          [_vModelText, _ctx.businessInformation.address.countryCode]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "Hamburg",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.businessInformation.address.region) = $event))
        }, null, 512), [
          [_vModelText, _ctx.businessInformation.address.region]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "Große Freiheit 7",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.businessInformation.address.firstLine) = $event))
        }, null, 512), [
          [_vModelText, _ctx.businessInformation.address.firstLine]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "20357",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.businessInformation.address.postalCode) = $event))
        }, null, 512), [
          [_vModelText, _ctx.businessInformation.address.postalCode]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "Hamburg",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.businessInformation.address.city) = $event))
        }, null, 512), [
          [_vModelText, _ctx.businessInformation.address.city]
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary float-end mt-4 mb-2",
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
      disabled: _ctx.noAddress
    }, _toDisplayString(_ctx.storing ? 'Updating' : 'Update'), 9, _hoisted_21),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_22, " An error has occurred please check your input. "))
      : _createCommentVNode("", true),
    _hoisted_23
  ]))
}